<template>
  <div
    class="mall-profile-card"
    :class="{ 'mall-profile-card--selected': selected }"
    @click="$emit('click')"
  >
    <div class="mall-profile-card__info">
      <div class="mall-profile-card__name-row">
        <span class="typo-body-m-medium mall-profile-card__name">{{ profile.name }}</span>
        <span v-if="profile.isDelegated" class="mall-profile-card__badge">위임장 등록 완료</span>
      </div>
      <span class="typo-body-s-medium">{{ subText }}</span>
      <span class="typo-body-s-medium">{{ profile.diseaseType }}</span>
    </div>
    <img
      v-if="selected"
      class="mall-profile-card__check"
      src="@/assets/mall/icn_check_line_blue.svg"
      alt="선택됨"
    />
    <img
      v-else
      class="mall-profile-card__check"
      src="@/assets/mall/icn_check_line_gray.svg"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: 'MallProfileCard',
  props: {
    profile: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 관계 · 생년월일 (값이 없는 항목은 빼고 표시)
    subText() {
      return [this.profile.relation, this.profile.birth].filter(text => !!text).join(' · ')
    },
  },
}
</script>

<style scoped>
.mall-profile-card {
  display: flex;
  width: 100%;
  padding: 18px 14px;
  align-items: center;
  gap: 4px;
  border: 1px solid #E5E8EB;
  border-radius: 12px;
  background: #F9FAFB;
  box-sizing: border-box;
  cursor: pointer;
}

.mall-profile-card--selected {
  border-color: #59BAFF;
  background: #EFF9FF;
}

.mall-profile-card__info {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.mall-profile-card__name-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mall-profile-card__name {
  color: var(--color-text-main);
}

.mall-profile-card__badge {
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #EFF9FF;
  color: var(--color-text-accent);
  font-family: Pretendard;
  font-size: var(--font-size-xxs);
  font-weight: var(--font-weight-medium);
  line-height: 130%;
  white-space: nowrap;
}

.mall-profile-card__check {
  display: block;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallProfileCard.vue